import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { MotionProvider } from './context/MotionContext';
import ScanlineOverlay from './components/ui/ScanlineOverlay';
import DistributorBanner from './components/ui/DistributorBanner';
import ParticleField from './components/effects/ParticleField';
import CursorParticles from './components/effects/CursorParticles';
import VerticalSectionTracker from './components/navigation/VerticalSectionTracker';
import PageTransition from './components/ui/PageTransition';

// Pages
import HomePage from './pages/HomePage';
import ProductsLandingPage from './pages/ProductsLandingPage';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import SystemSolutionsPage from './pages/SystemSolutionsPage';
import SystemDetailPage from './pages/SystemDetailPage';
import ServiceSupportPage from './pages/ServiceSupportPage';
import CompanyPage from './pages/CompanyPage';
import EventsPage from './pages/EventsPage';
import ContactPHPage from './pages/ContactPHPage';
import PietTechnologyPage from './pages/PietTechnologyPage';
import MedicalFieldPage from './pages/MedicalFieldPage';
import MedicalFieldsLandingPage from './pages/MedicalFieldsLandingPage';
import ClinicalEvidencePage from './pages/ClinicalEvidencePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AnalyticsScripts from './components/seo/AnalyticsScripts';

function App() {
  return (
    <HelmetProvider>
    <MotionProvider>
      <div className="App">
        <ParticleField />
        <CursorParticles />
        <DistributorBanner />
        <BrowserRouter>
          <PageTransition />
          <VerticalSectionTracker />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsLandingPage />} />
            <Route path="/products/:categorySlug" element={<CategoryPage />} />
            <Route path="/products/:categorySlug/:productSlug" element={<ProductPage />} />
            <Route path="/system-solutions" element={<SystemSolutionsPage />} />
            <Route path="/system-solutions/:systemSlug" element={<SystemDetailPage />} />
            <Route path="/contact-ph" element={<ContactPHPage />} />
            <Route path="/service-support" element={<ServiceSupportPage />} />
            <Route path="/company" element={<CompanyPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/technology/piet" element={<PietTechnologyPage />} />
            <Route path="/medical-fields" element={<MedicalFieldsLandingPage />} />
            <Route path="/clinical-evidence" element={<ClinicalEvidencePage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/medical-fields/:fieldSlug" element={<MedicalFieldPage />} />
          </Routes>
        </BrowserRouter>
        <AnalyticsScripts />
        <ScanlineOverlay />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#0a0a0a',
              border: '1px solid rgba(0, 255, 209, 0.3)',
              color: '#fff',
            },
          }}
        />
      </div>
    </MotionProvider>
    </HelmetProvider>
  );
}

export default App;
